module.exports = __webpack_public_path__ + "media/images/default-promo-4c54cd0861ca0117bd42862a6858d15d.jpg";